import React from "react"
import "material-symbols/outlined.css"
import Box, { BoxProps } from "@mui/material/Box"

enum MatSymbolVariants {
  OUTLINED = "outlined",
  ROUNDED = "rounded",
  SHARP = "sharp",
}

export interface MatSymbolProps extends BoxProps {
  size?: string | number,
  variant?: MatSymbolVariants,
  name: string,
}

export const MatSymbol = ({
  color = "rgba(0,0,0,.55)",
  name,
  variant = MatSymbolVariants.OUTLINED,
  size = 22,
  sx,
  ...props
}: MatSymbolProps) => (
  <Box
    component="span"
    className={`material-symbols-${variant}`}
    sx={{
      color,
      fontSize: size,
      height: size,
      width: size,
      ...sx
    }}
    {...props}
  >
    {name}
  </Box>
)
